var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "#E5EDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 19.3333V27.3667V27.3333V40.6667V19.3333ZM23.3333 32.6667H28C28.2 32.1556 28.4444 31.6778 28.7333 31.2333C29.0222 30.7889 29.3556 30.3778 29.7333 30H23.3333V32.6667ZM23.3333 38H27.5667C27.4556 37.5556 27.3836 37.1111 27.3507 36.6667C27.3178 36.2222 27.3231 35.7778 27.3667 35.3333H23.3333V38ZM18 43.3333V16.6667H31.3333L39.3333 24.6667V28C38.9111 27.8222 38.4778 27.6836 38.0333 27.584C37.5889 27.4844 37.1333 27.412 36.6667 27.3667V26H30V19.3333H20.6667V40.6667H28.7C29.0556 41.2 29.4556 41.6947 29.9 42.1507C30.3444 42.6067 30.8333 43.0009 31.3667 43.3333H18ZM36 39.3333C36.9333 39.3333 37.7222 39.0111 38.3667 38.3667C39.0111 37.7222 39.3333 36.9333 39.3333 36C39.3333 35.0667 39.0111 34.2778 38.3667 33.6333C37.7222 32.9889 36.9333 32.6667 36 32.6667C35.0667 32.6667 34.2778 32.9889 33.6333 33.6333C32.9889 34.2778 32.6667 35.0667 32.6667 36C32.6667 36.9333 32.9889 37.7222 33.6333 38.3667C34.2778 39.0111 35.0667 39.3333 36 39.3333ZM42.8 44.6667L39.2 41.0667C38.7333 41.3778 38.228 41.6111 37.684 41.7667C37.14 41.9222 36.5787 42 36 42C34.3333 42 32.9169 41.4169 31.7507 40.2507C30.5844 39.0844 30.0009 37.6676 30 36C30 34.3333 30.5836 32.9169 31.7507 31.7507C32.9178 30.5844 34.3342 30.0009 36 30C37.6667 30 39.0836 30.5836 40.2507 31.7507C41.4178 32.9178 42.0009 34.3342 42 36C42 36.5778 41.9222 37.1391 41.7667 37.684C41.6111 38.2289 41.3778 38.7342 41.0667 39.2L44.6667 42.8L42.8 44.6667Z",
    fill: "#2E3438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference);
export default __webpack_public_path__ + "static/media/reference.18490dee2284d2cde83a3ee74451e0a3.svg";
export { ForwardRef as ReactComponent };